import { useEffect } from "react";
import "./assets/css/Style.css";
import "./assets/css/Form-element.css";
import imglogo from "./assets/img/questmath-logo-blue.png";
import imgdelete from "./assets/img/delete.png";
import backarrowwhite from "./assets/img/back-arrow-white.svg";
import arrowblue1 from "./assets/img/arrow_blue_1.svg";
import arrowblue2 from "./assets/img/arrow_blue_2.svg";

export default function Regslot() {
  useEffect(() => {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    console.log("Height: " + vh);
  }, []);

  return (
    <>
    <div class="main-container shortDistance">
        <div class="inner-container left-container left-bg ">
            <div class="curve-container">
            	<div class="back_button">
            		<img src={backarrowwhite} />
            	</div>
                <div class="">
                    <div class="register-steps">
                        <div></div>
                        <div></div>
                        <div class="selected"></div>
                    </div>
                    <div class="register-titles">
                        <div class="register-title">Select a time slot</div>
                        <div class="register-sub-title">For your free trial class</div>
                    </div>
                </div>
                <div class="form-row-custom registration_box">
                	<div id="registrationTab1" class="">	
						 <ul class="nav nav-tabs col-lg-12" role="tablist">
						    <li role="presentation" class=" title col-lg-6 col-md-6 col-sm-6 col-6 text-center"><a href="#home" aria-controls="home" role="tab" data-toggle="tab" class="active">Home</a></li>
						    <li role="presentation" class="col-lg-6 col-md-6 col-sm-6 col-6 title text-center"><a href="#profile" aria-controls="profile" role="tab" data-toggle="tab" class="">Profile</a></li>
						  </ul>

						  <div class="tab-content">
						    <div role="tabpanel" class="tab-pane active" id="home">
						    	<div class="col-lg-12 p-3">
						    		<div class="row">
							    		<div class="col-lg-1 col-md-1 col-sm-1 col-1 p-0 arrow">
							    			<img src={arrowblue2} />
							    		</div>
							    		<div class="col-lg-10 col-md-10 col-sm-10 col-10">
							    			<div class="col-lg-12">
							    				<div class="row slots">
							    					<div class="col-lg-4 col-md-4 col-sm-4 col-4 text-center">
							    						<div>MON</div>
							    						<div>14 Sep</div>
							    					</div>
							    					<div class="col-lg-4 col-md-4 col-sm-4 col-4 text-center active">
							    						<div>TUE</div>
							    						<div>15 Sep</div>
							    					</div>
							    					<div class="col-lg-4 col-md-4 col-sm-4 col-4 text-center">
							    						<div>WED</div>
							    						<div>16 Sep</div>
							    					</div>
							    				</div>
							    			</div>
							    		</div>
							    		<div class="col-lg-1 col-md-1 col-sm-1 col-1 p-0 arrow">
							    			<img src={arrowblue1} />
							    		</div>
							    	</div>
						    	</div>
						    	<div class="col-lg-12 slot_time_card">
						    		<div class="row">
						    			<div class="col-lg-4 pb-3">
						    				<div class="col-lg-12 active slot_time active">
							    				10 : 00 AM - 11 : 00 AM
							    			</div>
						    			</div>
						    			<div class="col-lg-4 pb-3">
							    			<div class="col-lg-12 slot_time disabled">
							    				11 : 00 AM - 12 : 00 AM
							    			</div>
						    			</div>
						    			<div class="col-lg-4 pb-3">
							    			<div class="col-lg-12 slot_time">
							    				12 : 00 AM - 01 : 00 PM
						    			</div>
						    			</div>
						    			<div class="col-lg-4 pb-3">
							    			<div class="col-lg-12 slot_time">
							    				01 : 00 PM - 02 : 00 PM
							    			</div>
						    			</div>
						    			<div class="col-lg-4 pb-3">
							    			<div class="col-lg-12 slot_time">
							    				03 : 00 PM - 04 : 00 PM
							    			</div>
						    			</div>
						    			<div class="col-lg-4 pb-3">
							    			<div class="col-lg-12 slot_time">
							    				04 : 00 PM - 05 : 00 PM
							    			</div>
						    			</div>
						    			
						    		</div>
						    	</div>
						    </div>
						    <div role="tabpanel" class="tab-pane" id="profile">
						    	<div class="col-lg-12 p-3">
						    		<div class="row">
							    		<div class="col-lg-1 col-md-1 col-sm-1 col-1 p-0 arrow">
							    			<img src={arrowblue2} />
							    		</div>
							    		<div class="col-lg-10 col-md-10 col-sm-10 col-10">
							    			<div class="col-lg-12">
							    				<div class="row slots">
							    					<div class="col-lg-4 col-md-4 col-sm-4 col-4 text-center">
							    						<div>MON</div>
							    						<div>14 Sep</div>
							    					</div>
							    					<div class="col-lg-4 col-md-4 col-sm-4 col-4 text-center active">
							    						<div>TUE</div>
							    						<div>15 Sep</div>
							    					</div>
							    					<div class="col-lg-4 col-md-4 col-sm-4 col-4 text-center">
							    						<div>WED</div>
							    						<div>16 Sep</div>
							    					</div>
							    				</div>
							    			</div>
							    		</div>
							    		<div class="col-lg-1 col-md-1 col-sm-1 col-1 p-0 arrow">
							    			<img src={arrowblue1} />
							    		</div>
							    	</div>
						    	</div>
						    	<div class="col-lg-12 slot_time_card">
						    		<div class="row">
						    			<div class="col-lg-6 pb-3">
						    				<div class="col-lg-12 active slot_time active">
							    				10 : 00 AM - 11 : 00 AM
							    			</div>
						    			</div>
						    			<div class="col-lg-6 pb-3">
							    			<div class="col-lg-12 slot_time disabled">
							    				11 : 00 AM - 12 : 00 AM
							    			</div>
						    			</div>
						    			<div class="col-lg-6 pb-3">
							    			<div class="col-lg-12 slot_time">
							    				12 : 00 AM - 01 : 00 PM
						    			</div>
						    			</div>
						    			<div class="col-lg-6 pb-3">
							    			<div class="col-lg-12 slot_time">
							    				01 : 00 PM - 02 : 00 PM
							    			</div>
						    			</div>
						    			
						    		</div>
						    	</div>
						    </div>
						  </div>
					</div>

                </div>
                <div class="">
                    <div class="form-row-custom register-form-btn mb-0">
                        <button class="quest-btn quest-primary-btn" onclick="window.location.href='login.html'">Submit</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="inner-container right-container right-bg">
            <div class="register-right-container">
                <div class="register-right-titles">
                    <div class="register-right-sub-title">Welcome to </div>
                    <div class="register-right-title">
                        <img src={imglogo} class="img-fluid" alt="QuestMath Blue Logo" />
                    </div>
                </div>
                <div class="register-features-container hideinsmallscreen">
                    <div class="register-features-row">
                        <div class="feature-card">
                            <div class="feature-title">
                                INDIVIDUAL ATTENTION<br />
                                <span>1 : 1 Class with mentor</span>
                            </div>
                            <div class="icon-container">
                                <img src={imgdelete} class="img-fluid" />
                            </div>
                        </div>
                    </div>
                    <div class="register-features-row card-right">
                        <div class="feature-card">
                            <div class="icon-container">
                                <img src={imgdelete} class="img-fluid" />
                            </div>
                            <div class="feature-title">
                                EXCLUSIVE WORKOUTS<br />
                                <span>Practice workoouts for free</span>
                            </div>
                        </div>
                    </div>
                    <div class="register-features-row">
                        <div class="feature-card">
                            <div class="feature-title">
                                UNLOCK REWARDS<br />
                                <span>Earn rewards while learning</span>
                            </div>
                            <div class="icon-container">
                                <img src={imgdelete} class="img-fluid" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    </>
  );
}
